import loader from '../moduleLoader';
import BeerSlider from 'beerslider';
// CSS have been moved to leagacy css file to patch safari issue
//import 'beerslider/dist/BeerSlider.css';

class ImageComparison {
    constructor(container) {
        this.container = container;
    }
    init() {
        new BeerSlider(this.container, { start: 33 });
    }
}

loader.add('ImageComparison', ImageComparison);
export default ImageComparison;